import React from 'react';

import { IconTooltip } from 'utils/components/IconTooltip';

export default function ObvTileChartHelp() {
    return (
        <IconTooltip>
            <div>
                The OBV (on-balance volume) chart captures crowd sentiment,
                since it is thought that a dramatic change in trading volume
                often reflects the market’s attitude towards a particular
                security.
                <br /> <br />
                In line with this, it is feasible to assume that positive
                sentiment may drive the security price higher, whereas negative
                sentiment may drive the security price lower. With this
                knowledge, a trading system might be developed to exploit sudden
                and dramatic changes in trading volume, with buy and sell
                signals initiated following either an uptick (increased OBV) or
                downtick (decreased OBV) in trading volume, respectively.
                <br /> <br />
                The OBV Capsule can be configured by selecting a symbol from
                your portfolio or adding it in settings, and setting the time
                range.
            </div>
        </IconTooltip>
    );
}
